import axios from 'axios';

import router from '@/core/router';
import store from '@/store';
import { sendMessageToSentry } from '@/utilities/sentry.js';

const request = axios.create({
  baseURL: process.env.API_URL,
});

request.interceptors.request.use(
  (config) => {
    config.headers['Content-Language'] = store.state.userLang;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

request.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      store.commit('setInternalError', true);

      sendMessageToSentry('ApiNoErrorResponse', { level: 'error' });
    }

    if (error.response.status >= 500 || error.response.data?.is_redirect_error_page === 1) {
      sendMessageToSentry(`RedirectToErrorPage-${error.response.config.url}`, {
        level: 'error',
        extra: [
          {
            name: 'errorCode',
            value: error.response.status,
          },
          {
            name: 'error',
            value: error.response,
          },
        ],
      });

      const errorCode = error.response.data?.error_page_code;
      const trackID = error.response.data?.track_id || null;
      if (errorCode) {
        router.push({
          name: 'error',
          query: { code: errorCode, track_id: trackID },
        });
      } else {
        router.push({ name: 'error' });
      }
    }

    return Promise.reject(error);
  },
);

export default request;
